import { environment } from "../../environments/environment";
import { MenuItems } from "./menuItems";

/** JSW Aadhaar VMD gateway `apiReqId` values on getApiRequestResultsData / update payloads */
const jswVmdApiReqIds = {
  API_REQ_ID_VENDOR: "501C61E5AF525FDBE0650250569B190D",
  API_REQ_ID_REQUESTOR: "5022705F32F25108E0650250569B190D",
  API_REQ_ID_CHANGE_REQUESTS: "5021194452762D19E0650250569B190D",
  /** updateInsertDeleteApiRequestData when posting a new change request */
  API_REQ_ID_UPDATE: "502EFCE6CE980DCAE0650250569B190D",
  /** updateInsertDeleteApiRequestData when editing / resubmitting a change request */
  API_REQ_ID_UPDATE_EDIT: "51C642A47950BD2FE0650250569B190D",
  /** updateInsertDeleteApiRequestData when posting change-request attachments */
  API_REQ_ID_ATTACHMENT: "51D86FCC4B696813E0650250569B190D",
  /** Change Request Status lookup via getApiRequestResultsData */
  API_REQ_ID_STATUS: "502EFCE6CE9B0DCAE0650250569B190D",
};

/** JSW Aadhaar gateway URL path segments (append after root URL that ends with `/`). */
const jswVmdGatewayPaths = {
  API_AUTH_TOKEN: "apiAuthToken",
  GET_API_REQUEST_RESULTS_DATA: "getApiRequestResultsData",
  UPDATE_INSERT_DELETE_API_REQUEST_DATA: "updateInsertDeleteApiRequestData",
};

const urls = {
  // Auth
  LOGIN: `${environment.dataUrl}auth/login`,
  FORGOTPASSWORD: `${environment.base}forgotPwd`,
  CHANGEPASSWORD: `${environment.base}updatePwd`, //reset password
  FORCECHANGEPASSWORD: `${environment.base}updatePwd`, //onboarding
  RESETPASSWORD: `${environment.base}updatePwd`, //forgot password
  LOGOUT: `${environment.base}logout`,
  VENDORMASTERDATA: `${environment.dataUrl}jsw/getSupplier`,

  //OLD API CALLS
  // LOGIN: `${environment.base}padd/app/login`,
  // FORGOTPASSWORD: `${environment.base}payexap/api/forgottenPasswordReg`,
  // CHANGEPASSWORD: `${environment.base}dashboard/resetPassword`,
  // FORCECHANGEPASSWORD: `${environment.base}dashboard/resetPassword_ob`,
  // RESETPASSWORD: `${environment.base}payexap/api/forgottenPassword`,

  //DASHBOARD
  ANALYTICS: `${environment.base}dashboard/fetchAnalytics`,
  ANALYTICSINVOICE: `${environment.base}dashboard/fetchAnalyticsInvoice`,
  ANALYTICSPO: `${environment.base}dashboard/fetchAnalyticsPo`,
  ANALYTICSEXTERNAL: `${environment.dataUrl}jsw/getAnalyticsExternal`,
  IMPERSONATE: `${environment.dataUrl}auth/impersonate`,

  INVOICE_ANALYTICS: `${environment.dataUrl}jsw/stats/invoice_analytics`,
  PO_ANALYTICS: `${environment.dataUrl}jsw/stats/po_analytics`,

  //INVOICES
  INVOICES: `${environment.base}dashboard/fetchInvoice`,
  EXTRACTINVOICE: `${environment.base}apSaas/extractEInvoiceData`,
  SUBMITINVOICE: `${environment.base}dashboard/uploadInvoice`,
  SAVEINVOICE: `${environment.base}dashboard/saveInvoiceUploadProcess`,
  VERIFYSIGNATURE: `${environment.base}apSaas/verifyDigitallySignedInvoice`,
  SUBMITINVOICEWITHOUTEXTRACT: `${environment.base}dashboard/invoiceCrudWithSupDoc`,
  SUBMITINVOICETOJSW: `${environment.base}dashboard/submitInvoiceToJSW`,
  GETINVOICEDETAILS: `${environment.dataUrl}jsw/getInvoiceDetails`,

  //PURCHASE ORDERS
  PURCHASEORDERDETAILS: `${environment.dataUrl}jsw/fetchPoNew`,
  PURCHASEODERS: `${environment.dataUrl}listresultservice/getinvoicesAggregate`,
  GETINVOICES: `${environment.dataUrl}listresultservice/getinvoices`,
  GET_CN_DN: `${environment.dataUrl}listresultservice/getCNDN`,

  LINEITEMS: `${environment.dataUrl}listresultservice/getLedgerLineItems`,
  MATERIALPOS: `${environment.dataUrl}jsw/getMaterialPos`,

  //CONFIG FOR ORGANIZATION
  FETCHCONFIG: `${environment.base}fetchConfig`,
  GET_CONFIG: `${environment.dataUrl}jsw/getConfig`,
  GET_ALL_CONFIG: `${environment.dataUrl}jsw/getAllConfig`,

  REGISTER_VENDOR: `${environment.dataUrl}update/registerSupplier`,
  UPLOAD_DOCS: `${environment.base}dashboard/uploadSupDoc`,

  //Query Management
  GETQUERY: `${environment.dataUrl}listresultservice/getSaveVendorQuery`,
  SAVEQUERY: `${environment.base}dashboard/supplier/saveVendorQuery`,
  GETBARCODES: `${environment.dataUrl}jsw/getbarcode`,

  GETTICKET: `${environment.dataUrl}jsw/getTicket`,
  CREATETICKETS: `${environment.gbsAPI}create?tenantDB=ims`,
  CREATETICKET: `${environment.dataUrl}jsw/createTicket`,
  UPLOADTICKETATTACHMENT: `${environment.dataUrl}jsw/uploadTicketAttachment`,

  //Change Requests
  SUBMIT_CHANGE_REQUEST: `${environment.dataUrl}jswVMD/changeRequest`,
  LIST_CHANGE_REQUESTS: `${environment.dataUrl}jswVMD/list`,
  LIST_PENDING_CHANGE_REQUESTS: `${environment.dataUrl}jswVMD/pending`,
  GET_CHANGE_REQUEST_DETAIL: `${environment.dataUrl}jswVMD/detail`,
  UPDATE_CHANGE_REQUEST_STATUS: `${environment.dataUrl}jswVMD/updateStatus`,
  /** Mongo `uiConfig` document `_id: "JSW"` (client id / secret for JSW Aadhaar gateway). */
  JSW_UI_CONFIG: `${environment.dataUrl}jswVMD/uiConfig`,

  // JSW gateway endpoints — backend makes server-to-server calls to aadhaar.jsw.in
  JSW_GATEWAY_AUTH_TOKEN:          `${environment.dataUrl}jswVMD/gateway/authToken`,
  JSW_GATEWAY_VENDOR_DETAILS:      `${environment.dataUrl}jswVMD/gateway/vendorDetails`,
  JSW_GATEWAY_REQUESTOR_DETAILS:   `${environment.dataUrl}jswVMD/gateway/requestorDetails`,
  JSW_GATEWAY_CHANGE_REQUESTS:     `${environment.dataUrl}jswVMD/gateway/changeRequests`,
  JSW_GATEWAY_SUBMIT_CR:           `${environment.dataUrl}jswVMD/gateway/submitCR`,
  JSW_GATEWAY_UPLOAD_ATTACHMENT:   `${environment.dataUrl}jswVMD/gateway/uploadAttachment`,
  JSW_GATEWAY_CR_STATUS:           `${environment.dataUrl}jswVMD/gateway/crStatus`,
  JSW_GATEWAY_BANK_DETAILS:        `${environment.dataUrl}jswVMD/gateway/bankDetails`,

  //s3 
  GET_SIGNED_URL: `${environment.dataUrl}upload/get-s3-url-generic`,

  //ACCENTURE API CALLS

  // Auth
  // LOGIN: `${environment.API.PayEXDC.url}login`,
  // FORGOTPASSWORD: `${environment.API.PayEXDC.url}forgotPwd`,
  // CHANGEPASSWORD: `${environment.API.PayEXDC.url}dashboard/resetPassword`,
  // Lists
  // GETDOCS: `${environment.API.PayEXDC.url}/getDocuments`,
  // GET_INVOICES: `${environment.API.ES.url}invoiceservice/getInvoices`,
  // GET_BUYERS: `${environment.API.ES.url}buyerservice/getbuyers`,
  // ****** PADD *******//

  //PAYEXAP_LOGIN: `${environment.API.PayEXDC.url}padd/app/login`,
  // PADD - Landing Page Summary
  // PAYEXAP_LANDINGPAGE_SUMMARY: `${environment.BASE_URL}/dashboard/landingPageSummary`,
  // PAYEXAP_DASHBOARD: `${environment.BASE_URL}/dashboard/apStatusDashboard`,
  // PAYEXAP_SUPPLIER_ADMIN_DASHBOARD: `${environment.BASE_URL}/dashboard/payexapApp/supplierApStatusDashboard`,
  // PAYEXAP_DASHBOARD_GRAPH: `${environment.BASE_URL}/dashboard/apPaidVsOpenDashboard`,
  // PAYEXAP_SUPPLIER_ADMIN_DASHBOARD_GRAPH: `${environment.BASE_URL}/dashboard/payexapApp/supplierApPaidVsOpenDashboard`,
  // PADD - Sellers
  // PAYEXAP_GETSELLERS: `${environment.BASE_URL}/dashboard/admin/sellers/list`,
  // PAYEXAP_ADD_SELLER: `${environment.BASE_URL}/dashboard/admin/sellers/onboard`,
  // PAYEXAP_GET_SELLER: `${environment.BASE_URL}/dashboard/admin/sellers/view/`,
  // PAYEXAP_EDIT_SELLER: `${environment.BASE_URL}/dashboard/admin/sellers/modify/`,
  // PAYEXAP_GET_SELLER_LEDGER_SUMMARY: `${environment.BASE_URL}/dashboard/apLedger/summary/`,
  // PADD - Suppliers
  // PAYEXAP_GETSUPPLIERS: `${environment.BASE_URL}/dashboard/supplierList`,
  // PAYEXAP_ADD_SUPPLIER: `${environment.BASE_URL}/dashboard/supplier`,
  // PAYEXAP_GET_SUPPLIER: `${environment.BASE_URL}/dashboard/supplier/`,
  // PAYEXAP_EDIT_SUPPLIER: `${environment.BASE_URL}/dashboard/supplier/`,
  // PAYEXAP_UPLOAD_SUPPLIER: `${environment.BASE_URL}/dashboard/supplierUpload/`,
  // PADD - Invoices
  // PAYEXAP_GETINVOICES: `${environment.BASE_URL}/dashboard/apinvoice`,
  // PAYEXAP_SUPPLIER_GETINVOICES: `${environment.BASE_URL}/dashboard/payexapApp/supplierApinvoice`,
  // PAYEXAP_ADD_INVOICE: `${environment.BASE_URL}/dashboard/apinvoice`,
  // PAYEXAP_SUPPLIER_ADD_INVOICE: `${environment.BASE_URL}/dashboard/payexapApp/supplierApinvoice`,
  // PAYEXAP_GET_INVOICE: `${environment.BASE_URL}/dashboard/apLedger`,
  // PAYEXAP_SUPPLIER_GET_INVOICE: `${environment.BASE_URL}/dashboard/payexapApp/apLedger`,
  // PAYEXAP_EDIT_INVOICE: `${environment.BASE_URL}/dashboard/apLedger`,
  // PAYEXAP_UPLOAD_INVOICE: `${environment.BASE_URL}/dashboard/pdfReader`,
  // PAYEXAP_UPLOAD_INVOICE_TO_STORAGE_SERVER: `${environment.BASE_URL}/dashboard/apinvUpload`,
  // PAYEXAP_UPLOAD_EDIT_INVOICE: `${environment.BASE_URL}/dashboard/ledgerEditUpload`,
  // PAYEXAP_INVOICE_PAYMENT: `${environment.BASE_URL}/dashboard/apinvoicePayment`,
  // PAYEXAP_SUPPLIER_ADMIN_INVOICE_PAYMENT: `${environment.BASE_URL}/dashboard/payexapApp/apinvoicePayment`,
  // PAYEXAP_GET_SUPPLIER_BANK_INFO: `${environment.BASE_URL}/dashboard/supplierBank`,
  // PAYEXAP_GET_SELLER_BANK_INFO: `${environment.BASE_URL}/dashboard/admin/sellers/view/`,
  // PAYEXAP_PAYMENT: `${environment.BASE_URL}/dashboard/apPayment`,
  // PAYEXAP_DOWNLOAD_PAYMENT_INSTRUCTIONS: `${environment.BASE_URL}/dashboard/downloadApPayIns`,
  // PAYEXAP_UPLOAD_PAYMENT_RESPONSE: `${environment.BASE_URL}/dashboard/apPaymentUpload`,

  // PAYEXAP - Purchase Orders
  // PAYEXAP_GET_PURCHASE_ORDERS: `${environment.BASE_URL}/dashboard/po`,
  // PAYEXAP_SUPPLIER_ADMIN_GET_PURCHASE_ORDERS: `${environment.BASE_URL}/dashboard/payexapApp/supplierPo`,
  // PAYEXAP_UPLOAD_PURCHASE_ORDERS: `${environment.BASE_URL}/dashboard/poUpload`,

  // PAYEXAP - Purchase Orders
  // PAYEXAP_GET_PODs: `${environment.BASE_URL}/dashboard/pod`,
  // PAYEXAP_SUPPLIER_ADMIN_GET_PODs: `${environment.BASE_URL}/dashboard/payexapApp/supplierPod`,
  // PAYEXAP_UPLOAD_POD: `${environment.BASE_URL}/dashboard/podUpload`,

  // PAYEXAP - Recons
  // PAYEXAP_GET_RECONS: `${environment.BASE_URL}/dashboard/aprecon`,
  // PAYEXAP_UPLOAD_RECON_DISPUTE_RESOLUTION: `${environment.BASE_URL}/dashboard/apreconUpload`,
  // PAYEXAP_UPLOAD_INV_POD_RECON_DISPUTE_RESOLUTION: `${environment.BASE_URL}/dashboard/apreconInvUpload`,
  // PAYEXAP_GET_RECONS_DETAIL: `${environment.BASE_URL}/dashboard/offer`,
  // PAYEXAP_REQUEST_SUPPLIER_CN: `${environment.BASE_URL}/dashboard/apSendNoteRequest`,

  // PADD - Offers
  // PADD_GET_OFFERS: `${environment.API.PAYEXAP.url}dashboard/offer`,
  // PADD_GET_OFFER: `${environment.API.PAYEXAP.url}dashboard/offer`,
  // PADD_CREATE_OFFER: `${environment.API.PAYEXAP.url}dashboard/offer`,
  // PADD - Supplier - Offers
  // GENERATE_OTP: `${environment.API.PAYEXAP.url}padd/app/otp`,
  // PADD_GET_OFFER_LIST_FOR_SUPPLIER: `${environment.API.PAYEXAP.url}padd/app/offer`,
  // PADD_UPDATE_OFFER_BY_SUPPLIER: `${environment.API.PAYEXAP.url}padd/app/offer`,

  // PADD - Update Offers
  // PADD_LIST_UPDATEOFFERS: `${environment.API.PAYEXAP.url}dashboard/updateOffer`,
  // PADD_GET_UPDATEOFFERS: `${environment.API.PAYEXAP.url}dashboard/updateOffer`,
  // PADD_UPDATE_UPDATEOFFERS: `${environment.API.PAYEXAP.url}dashboard/updateOffer`,
};

const landingPageRouteConfig = {
  getsupplieroffer: { url: "app-flow/supplier" },
};

const pageSize = 15;

const productItemHeadings = {
  Seller: {
    single: "Seller",
    plural: "Sellers",
  },
};

export const Config = {
  urls,
  jswVmdApiReqIds,
  jswVmdGatewayPaths,
  pageSize,
  menuItems: MenuItems.menuItems,
  dateDisplayFormat: "DD-MMM-YYYY",
  dateSaveFormat: "YYYY-MM-DD",
  dateServiceFormat: "DD-MM-YYYY",
  landingPageRouteConfig,
  appName: environment.appName,
  productItemHeadings: productItemHeadings,
  maxFileSize: environment.environmentConfig.maxUploadFileSize || 25 * 1024 * 1024,
  maxTotalSupportingDocsSize: environment.environmentConfig.maxTotalSupportingDocsSize || 100 * 1024 * 1024,
  get maxFileSizeLabel() { return `25MB`; },
  get maxTotalSupportingDocsSizeLabel() { return `100MB`; },
};
